<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      shape="square"
      finish-button-text="Add Object"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >
      <!-- Object Information  -->
      <tab-content
        title="Info"
      >
        <add-object-info
          :new-object="newObject"
          :object-types="objectTypes"
        />
      </tab-content>

      <!-- Object Manufacturer  -->
      <tab-content
        title="Manufacturer"
      >
        <add-object-manufacturer
          :new-object="newObject"
        />
      </tab-content>

      <!-- Object Properties  -->
      <tab-content
        title="Object Properties"
      >
        <add-object-properties
          :new-object="newObject"
          :object-properties="objectProperties"
        />
      </tab-content>

      <!-- Assign Devices To Object -->
      <tab-content
        title="Assign Devices to Object"
      >
        <div v-if="devices.length > 0 ">
          <add-object-devices
            :new-object="newObject"
            :devices="devices"
          />
        </div>
        <div v-else>
          <p class="text-center">
            There are no devices in this workspace
          </p>

        </div></tab-content>
      <!-- Assign Devices To Object -->
      <tab-content

        title="Assign Object to Site"
      >
        <div v-if="sites.length > 0 ">
          <add-object-site

            :new-object="newObject"
            :sites="sites"
          />
        </div>
        <div v-else>
          <p class="text-center">
            There are no sites in this workspace
          </p>
        </div>

      </tab-content>
      <!-- Summary -->
      <tab-content
        title="Summary"
      >
        <add-object-summary :new-object="newObject" />
      </tab-content>

    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
// import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { API } from 'aws-amplify'
import * as mutations from '../../../graphql/mutations'
import * as queries from '../../../graphql/queries'
import AddObjectManufacturer from './AddObjectManufacturer.vue'
import AddObjectInfo from './AddObjectInfo.vue'
import AddObjectSummary from './AddObjectSummary.vue'
import AddObjectDevices from './AddObjectDevices.vue'
import AddObjectProperties from './AddObjectProperties.vue'
import AddObjectSite from './AddObjectSite.vue'

export default {
  components: {
    // ValidationObserver,
    FormWizard,
    TabContent,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AddObjectDevices,
    AddObjectManufacturer,
    AddObjectInfo,
    AddObjectProperties,
    AddObjectSite,
    AddObjectSummary,
  },
  data() {
    return {
      devices: [],
      sites: [],
      objectTypes: [],
      objectProperties: [],
      workspacetoken: '',
      newObject: {
        devices: [],
        properties: [],
        site: {},
        info: {
          name: '',
          serialNumber: '',
          manufacturer: '',
          model: '',
          modelNumber: '',
          type: {},
        },
      },
    }
  },
  watch: {
    newDevice: {
      deep: true,
      handler(newVal) {
        this.newDevice = newVal
      },
    },
  },
  created() {
    this.listEntites()
    this.listObjectTypes()
    this.listObjectProperties()
  },
  methods: {
    async listEntites() {
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: JSON.parse(localStorage.getItem('workspace')).id,
        },
      }).then(response => {
        this.devices = response.data.getWorkspace.devices.items
        this.sites = response.data.getWorkspace.sites.items
      })
    },
    async listObjectTypes() {
      const { currentWorkspace } = JSON.parse(localStorage.getItem('userData'))
      await API.graphql({
        query: queries.listObjectTypes,
        filter: { workspace: { eq: currentWorkspace } }, // Lägg till filter för att endast se devices som inte har object
      }).then(response => {
        this.objectTypes = response.data.listObjectTypes.items
      })
    },
    async listObjectProperties() {
      await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: JSON.parse(localStorage.getItem('workspace')).id,
        },
      }).then(response => {
        this.objectProperties = response.data.getWorkspace.objectProperties.items
      })
    },
    triggerToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
        },
      },
      {
        position: 'bottom-right',
      })
    },
    async formSubmitted() {
      const workspace = JSON.parse(localStorage.getItem('workspace'))
      const roles = ['admin', 'editor', 'viewer']
      const workspaceGroups = []
      roles.forEach(role => {
        workspaceGroups.push(`${workspace.id}.${role}`)
      })

      const addObject = {
        workspaceObjectsId: workspace.id,
        workspaceGroups,
        name: this.newObject.info.name,
      }

      // Create Object type if needed and use that id in addObject.objectTypeObjectsId
      if (Object.keys(this.newObject.info.type).length > 0) {
        if (this.newObject.info.type.id === undefined) {
          await API.graphql({
            query: mutations.createObjectType,
            variables: {
              input: {
                workspaceGroups,
                name: this.newObject.info.type.name,
              },
            },
          }).then(response => {
            if (response.errors) {
              this.triggerToast(response.errors[0], 'danger', 'InfoIcon')
            } else {
              addObject.objectTypeObjectsId = response.data.createObjectType.id
            }
          })
        } else {
          addObject.objectTypeObjectsId = this.newObject.info.type.id
        }
      }

      // Create Object Properties
      const createObjectPropertyPromises = this.newObject.properties.map(async property => {
        if (property.id === undefined) {
          const response = await API.graphql({
            query: mutations.createObjectProperty,
            variables: {
              input: {
                workspaceObjectPropertiesId: workspace.id,
                workspaceGroups,
                name: property.name,
              },
            },
          })
          const propertyWithId = { ...property, id: response.data.createObjectProperty.id }
          return propertyWithId
        }
        return property
      })

      const createdProperties = await Promise.all(createObjectPropertyPromises)
      addObject.properties = JSON.stringify(createdProperties)

      // Lägg till manufacturer om det finns
      if (this.newObject.info.manufacturer !== '') {
        addObject.manufacturer = this.newObject.info.manufacturer
      }
      // lägg till model om det finns
      if (this.newObject.info.model !== '') {
        addObject.model = this.newObject.info.model
      }
      // lägg till modelnummer om det finns
      if (this.newObject.info.modelNumber !== '') {
        addObject.modelNumber = this.newObject.info.modelNumber
      }
      // Lägg till serialnumber om det finns
      if (this.newObject.info.serialNumber !== '') {
        addObject.manufacturerSerialNumber = this.newObject.info.serialNumber
      }

      // Lägg till site om det finns
      if (Object.keys(this.newObject.site).length > 0) {
        addObject.siteObjectsId = this.newObject.site.id
      }

      // GRAPHQL CreateObject
      await API.graphql({
        query: mutations.createObject,
        variables: {
          input: addObject,
        },
      }).then(response => {
        if (response.errors) {
          this.triggerToast(response.errors[0], 'danger', 'InfoIcon')
        } else {
          // Uppdatera device med object id och placement on object
          if (this.newObject.devices.length > 0) {
            this.newObject.devices.forEach(async device => {
              const { positionOnObject } = device
              await API.graphql({
                query: mutations.updateDevice,
                variables: {
                  input: {
                    id: device.id,
                    positionOnObject,
                    objectDevicesId: response.data.createObject.id,
                  },
                },
              })
            })
          }
          this.triggerToast(`${response.data.createObject.name} created`, 'success', 'InfoIcon')
          this.$router.push('/objects')
        }
      })
    },
    validationNetwork() {
      return new Promise((resolve, reject) => {
        this.$refs.network.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormDevice() {
      return new Promise((resolve, reject) => {
        this.$refs.object.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormUnits() {
      return new Promise((resolve, reject) => {
        this.$refs.object.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-autosuggest.scss';
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  .repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
